import { useStore as useProductStore } from '@/stores/product';
import { lineWidth } from '@/constants/areaLineWidth';
import { TextShape } from '@/web-components/import-wizard/typings/pintura';
import { mm2px } from '../utils';

export function positionText(
  shape: TextShape,
  positionId: string,
  repositionText: boolean
) {
  const artworkSpaceConsumed = 0.97;
  let calcWidth = 0;
  let calcHeight = 0;

  const productStore = useProductStore();

  const currentPrintPosition = productStore.printPositions?.find((p) => {
    return p.id === positionId;
  });

  if (currentPrintPosition) {
    const {
      printArea,
      originalImageWebDpi,
      originalImageWidthPx,
      originalImageDpi,
    } = currentPrintPosition;
    const webImageWidthPx =
      (originalImageWidthPx * originalImageWebDpi) / originalImageDpi;
    const rectLineWidth = (lineWidth * webImageWidthPx) / 100;
    let areaWidth = 0;
    let areaHeight = 0;
    let areaRect = {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    };

    if (
      currentPrintPosition.printArea?.shapeType === 'Rectangle' ||
      currentPrintPosition.printArea?.shapeType === 'Ellipse'
    ) {
      areaRect = {
        x: productStore.area(positionId)[0]?.x,
        y: productStore.area(positionId)[0]?.y,
        w: mm2px(printArea.widthMm, originalImageWebDpi),
        h: mm2px(printArea.heightMm, originalImageWebDpi),
      };
      areaHeight = printArea.heightMm;
      areaWidth = printArea.widthMm;
    } else if (currentPrintPosition.printArea?.shapeType === 'Polygon') {
      const minX = Math.min(
        ...printArea.productPrintAreaPoints.map((o) => o.distanceFromLeftEdge)
      );
      const minY = Math.min(
        ...printArea.productPrintAreaPoints.map((o) => o.distanceFromTop)
      );
      const maxX = Math.max(
        ...printArea.productPrintAreaPoints.map((o) => o.distanceFromLeftEdge)
      );
      const maxY = Math.max(
        ...printArea.productPrintAreaPoints.map((o) => o.distanceFromTop)
      );

      areaRect = {
        x: minX - rectLineWidth / 2,
        y: minY - rectLineWidth / 2,
        w: mm2px(maxX - minX, originalImageWebDpi),
        h: mm2px(maxY - minY, originalImageWebDpi),
      };

      areaHeight = maxY - minY;
      areaWidth = maxX - minX;
    }

    calcWidth =
      (areaRect.w * shape.originalWidthMM * artworkSpaceConsumed) / areaWidth;
    calcHeight =
      (areaRect.h * shape.originalHeightMM * artworkSpaceConsumed) / areaHeight;

    const gapW =
      calcWidth > areaRect.w ? 0 : areaRect.w - calcWidth - lineWidth * 2;
    const gapH =
      calcHeight > areaRect.h ? 0 : areaRect.h - calcHeight - lineWidth * 2;

    if (repositionText) {
      shape.y = areaRect.y + gapH / 2;
      shape.x = areaRect.x + lineWidth;

      const rotationInDegrees = currentPrintPosition?.printArea
        .rotation as number;
      shape.rotation = (rotationInDegrees * Math.PI) / 180;
    }

    shape.width = calcWidth;
    shape.height = calcHeight;
  }
}
